import { addMasthead, addNative } from '../shared';
export const adSlots = [
    addMasthead({
        slotId: '/199043128/360-selogerneuf/achat/general/page-de-liste/banner-haute-habillage',
        id: 'banner-haute-habillage',
    }),
    addNative({
        index: 1,
        slotId: '/199043128/360-selogerneuf/achat/general/page-de-liste/native1',
        id: 'native1',
    }),
    addNative({
        index: 2,
        slotId: '/199043128/360-selogerneuf/achat/general/page-de-liste/native2',
        id: 'native2',
    }),
    addNative({
        index: 3,
        slotId: '/199043128/360-selogerneuf/achat/general/page-de-liste/native3',
        id: 'native3',
    }),
];
